import { Injectable } from '@angular/core';
import {
    AppStateFacade,
    Setting,
} from '@app-state';
import { NugetType } from '@models';

@Injectable()
export class CommonNugetService {
    constructor(private _appState: AppStateFacade) { }

    public isNugetDownloadEnabled(type: NugetType) {
        return type === NugetType.Packages ?
            this._appState.settings.get(Setting.isPackagesInternalDeployment)! :
            this._appState.settings.get(Setting.isLibrariesInternalDeployment)!;
    }
}
